import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { WishListNavComponent } from './wish-list-nav/wish-list-nav.component';
import { CartNavComponent } from './cart-nav/cart-nav.component';
import { OKTA_AUTH } from '@okta/okta-angular';
import { HolidayTypes } from '../../../shared/enums/holiday-types.enum';
import { HolidayDataService } from '../../services/holiday-data.service';
import { AuthService } from '../../../auth/services/auth.service';
import { NotificationsNavComponent } from "./notifications-nav/notifications-nav.component";
import { TokenService } from '@utilities/services/token.service';
import { UserDataService } from '../../services/user-data.service';
import { share } from 'rxjs';
@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    RouterLinkActive,
    WishListNavComponent,
    CartNavComponent,
    NotificationsNavComponent,
    NotificationsNavComponent
  ],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  private authService = inject(AuthService);
  private tokenService = inject(TokenService);
  private oktaAuth = inject(OKTA_AUTH);
  private router = inject(Router);
  userDataService = inject(UserDataService);
  holidayDataService = inject(HolidayDataService);
  HolidayTypes = HolidayTypes;

  principalMenuItems = this.router.config
    .filter((route) => !!route.data && route.data['isPrincipalMenu'])
    .map((route) => ({
      title: route.title ?? '',
      path: route.path ?? '',
    }));

  ngOnInit(): void {
   let sharedWishlist = this.tokenService.isLoginSharedWishList();
    if (sharedWishlist) {
        this.router.navigate(['/shared-home/rewards']);
        return;
    }
  }

  async logOut() {
    let permission = this.tokenService.getTokenPermission();
    let tokenIncog = this.tokenService.getTokenIncog();
    let redirect = this.tokenService.getRedirect();
    if (tokenIncog) {
      if (permission == "readOnly") {
        if (redirect) {
          this.authService.logout();
          window.location.href = redirect;
          return;
        }
      }
    }
    if (this.oktaAuth.getAccessToken()) {
      await this.oktaAuth.signOut(
        {
          postLogoutRedirectUri: window.location.origin + '/'
        }
      );
    }
    if (this.authService.isLoggedIn()) {
      this.authService.logout();
    }

    this.router.navigate(['']);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
}
